import React, { useCallback, useEffect, useState, useRef } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { generateSupplierBasicInfoChangeLog, checkIsPhoneNumberValid, checkIsEmailValid, isDiffTwoObj, getAbbreviatedState, getParsedAddress } from '../../../../services/helper'
import ReactPhoneInput from "react-phone-input-2";
import 'react-phone-input-2/lib/style.css'
import { Loader, Modal } from 'rsuite';
import { BsCheckSquare, BsXSquare } from 'react-icons/bs'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import { updateSupplierBasicInfo, addSupplierHistory, assignChildToMasterSupplier } from '../../../../redux/actions/vendor'
import { MdOutlineChangeCircle } from 'react-icons/md';
import SearchModal from '../../../MyListsComponent/listInformationModal/search-modal';
import CreateMasterModal from '../../modals/create-master';
import ModalComponent from '../../../CommonComponents/Modal';
import CreateChildVendorFromMaster from '../SupplyComponent/createChildVendorFromMaster';
import { parseFullAddress } from '../../../../redux/actions/upload';
import ContactView from '../../../ContactsComponent/contactView';
import { getContacts, getExistingContacts } from '../../../../redux/actions/contact';
import AllContacts from '../../../ContactsComponent/allContacts';
import CreateContact from '../../../ContactsComponent/createContact';

const RelatedSupplyInformation = ({ isLocationMasterEditable, isLocationBasedMaster, onAssignedMaster, onUpdateCompletenessScore = () => { } }) => {
    const store = useStore().getState()
    const dispatch = useDispatch()
    const {
        app: {
            relatedSupplierColumns
        },
        vendor: {
            relatedSupplierDetails,
        },
        auth: { user }
    } = store

    const [supplierInfo, setSupplierInfo] = useState({})
    const [relatedSupplierInfo, setRelatedSupplierInfo] = useState({})
    const [supplierOldInfo, setSupplierOldInfo] = useState({})
    const [relatedSupplierOldInfo, setRelatedSupplierOldInfo] = useState({})
    const [isPhoneValid, setIsPhoneValid] = useState('')
    const [isNaicsValid, setIsNaicsValid] = useState(true)
    const [isSicValid, setIsSicValid] = useState(true)
    const [isValidatingPhone, setIsValidatingPhone] = useState(false)
    const [countryCode, setCountryCode] = useState('')
    const [isEmailValid, setIsEmailValid] = useState('')
    const [isEmailRisky, setIsEmailRisky] = useState('')
    const [isValidatingEmail, setIsValidatingEmail] = useState(false)
    const [showSearchOptions, setShowSearchOptions] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [showCreateMasterModal, setShowCreateMasterModal] = useState(false)
    const [isLocationMaster, setIsLocationMaster] = useState(false)
    const [showCreateChild, setShowCreateChild] = useState(false)
    const [isParsingAddress, setIsParsingAddress] = useState(false)
    const [showAllContacts, setShowAllContacts] = useState({
        email: false,
        phone: false
    })
    const [existedContacts, setExistedContacts] = useState([])
    const [isLoadingExistingContacts, setIsLoadingExistingContacts] = useState(false)
    const [currentContact, setCurrentContact] = useState({})
    const [showAddNewContact, setShowAddNewContact] = useState(false)
    const [contactDataFromField, setContactDataFromField] = useState({})
    const [allContacts, setAllContacts] = useState([])

    const phoneInputRefname = useRef(null);

    const setInitialSupplierInfo = useCallback((columns, supplierDetails) => {
        let supplierColumns = [...columns]
        supplierColumns.push({ name: 'phoneExtension', label: 'Phone Extension' })
        const tmpSupplierInfo = {}
        const tmpRelatedSupplierInfo = {}
        const usArray = ['united states', 'usa', 'us']
        supplierColumns.forEach(column => {
            const tmpValue = supplierDetails?.masterSupplierInfo?.baseInfo ? supplierDetails?.masterSupplierInfo?.baseInfo?.[column.name] : ''
            const tmpRelatedSupplierValue = supplierDetails?.baseInfo ? supplierDetails?.baseInfo?.[column.name] : ''
            if (column.name === 'state' || column.name === 'country') {
                tmpSupplierInfo[column.name] = /^[a-zA-Z\s]+$/.test(tmpValue) ? tmpValue : ''
                tmpRelatedSupplierInfo[column.name] = /^[a-zA-Z\s]+$/.test(tmpRelatedSupplierValue) ? tmpRelatedSupplierValue : ''
            } else if (column.name === 'phone') {
                // master supplier phone number
                const masterPhone = (tmpValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && /^\d+$/.test(tmpValue)) ? supplierDetails?.masterSupplierInfo?.contacts?.find(data => data?.id === parseInt(tmpValue))?.[column.name] : (tmpValue || '')
                tmpSupplierInfo.phoneContactId = (tmpValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && /^\d+$/.test(tmpValue)) ? supplierDetails?.masterSupplierInfo?.contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
                tmpSupplierInfo[column.name] = !masterPhone ? '' : masterPhone?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? masterPhone : supplierDetails?.masterSupplierInfo?.baseInfo?.['country'] && usArray.includes(supplierDetails?.masterSupplierInfo?.baseInfo?.['country']?.toLowerCase()) && masterPhone?.startsWith('1') ? masterPhone : ((supplierDetails?.masterSupplierInfo?.baseInfo?.['country'] && !usArray.includes(supplierDetails?.masterSupplierInfo?.baseInfo?.['country']?.toLowerCase()))) ? masterPhone : masterPhone?.startsWith('1') ? masterPhone : '1 ' + masterPhone
                // related supplier phone number
                const childPhone = (tmpRelatedSupplierValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpRelatedSupplierValue) && /^\d+$/.test(tmpRelatedSupplierValue)) ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpRelatedSupplierValue))?.[column.name] : (tmpRelatedSupplierValue || '')
                tmpRelatedSupplierInfo.phoneContactId = (tmpRelatedSupplierValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpRelatedSupplierValue) && /^\d+$/.test(tmpRelatedSupplierValue)) ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpRelatedSupplierValue))?.id : null

                tmpRelatedSupplierInfo[column.name] = !childPhone ? '' : childPhone?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? childPhone : supplierDetails?.baseInfo?.['country'] && usArray.includes(supplierDetails?.baseInfo?.['country'].toLowerCase()) && childPhone?.startsWith('1') ? childPhone : ((supplierDetails?.baseInfo?.['country'] && !usArray.includes(supplierDetails?.baseInfo?.['country'].toLowerCase()))) ? childPhone : childPhone.startsWith('1') ? childPhone : '1 ' + childPhone
            } else if (column.name === 'zip') {
                tmpSupplierInfo[column.name] = /^\d{5}(-\d{4})?$/.test(tmpValue) ? tmpValue : ''
                tmpRelatedSupplierInfo[column.name] = /^\d{5}(-\d{4})?$/.test(tmpRelatedSupplierValue) ? tmpRelatedSupplierValue : ''
            } else if (column.name === 'email') {
                var masterEmail = tmpValue && /^\d+$/.test(tmpValue) ? supplierDetails?.masterSupplierInfo?.contacts?.find(data => data?.id === parseInt(tmpValue))?.email : (tmpValue || '')
                tmpSupplierInfo.emailContactId = tmpValue && /^\d+$/.test(tmpValue) ? supplierDetails?.masterSupplierInfo?.contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
                tmpSupplierInfo[column.name] = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(masterEmail) ? masterEmail : ''
                //related supplier email
                var childEmail = tmpRelatedSupplierValue && /^\d+$/.test(tmpRelatedSupplierValue) ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpRelatedSupplierValue))?.email : (tmpRelatedSupplierValue || '')
                tmpRelatedSupplierInfo[column.name] = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(childEmail) ? childEmail : ''
                tmpRelatedSupplierInfo.emailContactId = tmpRelatedSupplierValue && /^\d+$/.test(tmpRelatedSupplierValue) ? supplierDetails?.contacts?.find(data => data?.id === parseInt(tmpRelatedSupplierValue))?.id : null
            } else if (column.name === 'abbreviatedState') {
                let masterStateCode = ''
                let childStateCode = ''
                if (supplierDetails?.masterSupplierInfo?.baseInfo?.abbreviatedState === null) {
                    masterStateCode = getAbbreviatedState(supplierDetails?.masterSupplierInfo?.baseInfo?.abbreviatedState, supplierDetails?.masterSupplierInfo?.baseInfo?.state)
                } else {
                    masterStateCode = supplierDetails?.masterSupplierInfo?.baseInfo?.abbreviatedState
                }
                if (supplierDetails?.baseInfo?.abbreviatedState === null) {
                    childStateCode = getAbbreviatedState(supplierDetails?.baseInfo?.abbreviatedState, supplierDetails?.baseInfo?.state)
                } else {
                    childStateCode = supplierDetails?.baseInfo?.abbreviatedState
                }
                tmpSupplierInfo[column.name] = masterStateCode
                tmpRelatedSupplierInfo[column.name] = childStateCode
            } else {
                tmpSupplierInfo[column.name] = tmpValue
                tmpRelatedSupplierInfo[column.name] = tmpRelatedSupplierValue
            }
        })
        tmpSupplierInfo["id"] = supplierDetails?.masterSupplierInfo?.baseInfo?.['id']
        tmpRelatedSupplierInfo["id"] = supplierDetails?.baseInfo?.['id']

        const isLocationMaster = (relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.isMaster && relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.masterId && relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.primaryMasterId) ? true : false
        setSupplierInfo(tmpSupplierInfo)
        setSupplierOldInfo(tmpSupplierInfo)
        setRelatedSupplierInfo(tmpRelatedSupplierInfo)
        setRelatedSupplierOldInfo(tmpRelatedSupplierInfo)
        setIsLocationMaster(isLocationMaster)
        setAllContacts(supplierDetails?.masterSupplierInfo?.contacts)
    }, [])

    useEffect(() => {
        // if (!relatedSupplierData[0]) {
        if (!relatedSupplierDetails || !relatedSupplierDetails?.relatedSupplierInfo) {
            return
        }
        if (!relatedSupplierColumns) {
            return
        }
        setInitialSupplierInfo(relatedSupplierColumns, relatedSupplierDetails?.relatedSupplierInfo)//relatedSupplierData[0]
        // }, [relatedSupplierData, relatedSupplierColumns, setInitialSupplierInfo])
    }, [relatedSupplierDetails, relatedSupplierColumns, setInitialSupplierInfo])

    useEffect(() => {
        if (Object.values(supplierInfo).length > 0 && !isValidatingPhone) {
            var phoneNumber = !supplierInfo?.['phone'] ? '' : supplierInfo?.['phone']
            handlePhoneNumberFocusOut(null, null, phoneNumber, true, supplierInfo)
            handleEmailFocusOut(supplierInfo?.['email'])
        }
    }, [Object.values(supplierInfo).length])

    const handleChangeSupplierInfo = (colName, value) => {
        let tmpValue = value
        if (colName === 'state' || colName === 'country') {
            if (/^[a-zA-Z\s]+$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^[a-zA-Z\s]+/gi) ? value.match(/^[a-zA-Z\s]+/gi)[0] : ''
            }
        } else if (colName === 'phone') {
            tmpValue = value
            if (!tmpValue) {
                setIsPhoneValid(true)
            } else {
                setIsPhoneValid(false)
            }
        } else if (colName === 'zip') {
            if (/^\d{5}(-\d{4})?$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{1,5}(-\d{0,4})?/gi) ? value.match(/^\d{1,5}(-\d{0,4})?/gi)[0] : ''
            }
        } else if (colName === 'naics') {
            tmpValue = value
            if (value === '' || /^(\d{5}|\d{6})?$/i.test(value)) {
                setIsNaicsValid(true)
            } else {
                setIsNaicsValid(false)
            }
        } else if (colName === 'sic') {
            tmpValue = value
            if (value === '' || /^\d{4}?$/i.test(value)) {
                setIsSicValid(true)
            } else {
                setIsSicValid(false)
            }
        } else if (colName === 'email') {
            if (!tmpValue) {
                setIsEmailValid(true)
            } else {
                setIsEmailValid(false)
            }
        } else if (colName === 'phoneExtension') {
            if (/^\d{20}$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{1,20}/gi) ? value.match(/^\d{1,20}/gi)[0] : ''
            }
        } else if (colName === 'employerIdNumber') {
            if (value.length === 3 && value.includes('-')) {
                value = value.replaceAll('-', '')
            } else if (value.length === 2 || value.length === 3) {
                if (value.length === 3) {
                    value = value.substring(0, 2) + '-' + value.substring(2)
                } else {
                    value += '-'
                }
            }
            if (/^\d{2}(-\d{7})?$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{1,2}(-\d{0,7})?/gi) ? value.match(/^\d{1,2}(-\d{0,7})?/gi)[0] : ''
            }
        } else if (colName === 'abbreviatedState') {
            let regex = /^[a-zA-Z\s]{2}$/
            let regex1 = /^[a-zA-Z\s]{1,2}/gi
            if (supplierInfo?.country && (supplierInfo?.country?.trim()?.toLowerCase() === 'australia' || supplierInfo?.country?.trim()?.toLowerCase() === 'aus')) {
                regex = /^[a-zA-Z\s]{3}$/
                regex1 = /^[a-zA-Z\s]{1,3}/gi
            }
            if (regex.test(value)) {
                tmpValue = value.trim().toUpperCase()
            } else {
                tmpValue = value.trim().match(regex1) ? value?.trim()?.match(regex1)[0]?.toUpperCase() : ''
            }
        }
        setSupplierInfo({
            ...supplierInfo,
            [colName]: tmpValue,
        })
    }

    const handlePhoneNumberFocusOut = async (event, country, phoneValue, isUseEffect = false) => {
        var countryCode = country && country.dialCode
        var phoneValueWithCode = phoneValue
        var testPhone = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
        if (testPhone !== '' && testPhone !== countryCode && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(testPhone)) {
            setIsPhoneValid(false)
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            return
        }

        if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
            return
        }
        if (phoneValue !== '') {
            setIsValidatingPhone(true)
            phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
            var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
            setIsPhoneValid(phoneValidationResult?.isPhoneValid)
            setIsValidatingPhone(phoneValidationResult?.isValidatingPhone)
        } else {
            setIsPhoneValid(true)
        }
        if (isUseEffect) {
            setSupplierInfo({ ...supplierInfo, 'phone': phoneValidationResult?.phoneNumber })
        }
    }

    const handlePhoneInputChange = (value, country, e, formattedValue) => {
        var phoneValue = formattedValue.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '').replace(/[^\w\s]|[\s]/gi, '')
        var countrycode = country.dialCode + ' '
        if (phoneValue !== '') {
            phoneValue = countrycode + phoneValue
            setIsPhoneValid('')
        } else {
            phoneValue = country.dialCode
            setIsPhoneValid(true)
        }
        if (e.target === null) {
            handlePhoneNumberFocusOut(e, country, formattedValue)
        }
        setCountryCode(country.dialCode)
        setSupplierInfo({
            ...supplierInfo,
            'phone': phoneValue === '' ? '' : phoneValue,
        })
    }

    const handleEmailFocusOut = async (emailValue, isRetry = false) => {
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            setIsEmailValid(false)
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!'
            })
            return
        }
        if (emailValue && emailValue !== '') {
            setIsValidatingEmail(true)
            var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
            setIsEmailValid(emailValidationResult?.isEmailValid)
            setIsValidatingEmail(emailValidationResult?.isValidatingEmail)
            setIsEmailRisky(emailValidationResult?.isEmailRisky)
        } else {
            setIsEmailValid(true)
        }
    }

    const handleKeyDown = (e, phoneInputRefname) => {
        if (e.keyCode === 9) {
            phoneInputRefname.current.props.onBlur()
        }
    }

    const handleCancelSupplierInfo = () => {
        setInitialSupplierInfo(relatedSupplierColumns, relatedSupplierDetails?.relatedSupplierInfo)
    }

    const handleSaveSupplierInfo = () => {
        if (countryCode === supplierInfo?.phone) {
            supplierInfo['phone'] = ''
        }
        if (isValidatingPhone) {
            toast.show({
                title: 'Warning',
                description: 'validating phone number...!',
            })
            return
        }
        if (isValidatingEmail) {
            toast.show({
                title: 'Warning',
                description: 'validating email...!',
            })
            return
        }

        if (!isEmailValid && isEmailValid !== '') {
            toast.show({
                title: 'Warning',
                description: 'Invalid Email'
            })
            return
        }
        if (isPhoneValid === false) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Phone Number.'
            })
            return
        }
        if (!isNaicsValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid NAICS Code. Must be atleast 5 or 6 digits long.'
            })
            return
        }
        if (!isSicValid) {
            toast.show({
                title: 'Warning',
                description: 'Invalid SIC Code. Must be atleast 4 digits long.'
            })
            return
        }
        if (supplierInfo?.employerIdNumber && supplierInfo?.employerIdNumber !== '' && !/^(\d{2}-\d{7})?$/.test(supplierInfo?.employerIdNumber)) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Employee Id Number. Must be 9 digit number formatted xx-xxxxxxx.'
            })
            return
        }

        if (supplierInfo?.abbreviatedState && supplierInfo?.abbreviatedState !== '') {
            let regex = /^[a-zA-Z\s]{2}$/
            let stateChars = '2'
            if (supplierInfo?.country && (supplierInfo?.country.trim().toLowerCase() === 'australia' || supplierInfo?.country.trim().toLowerCase() === 'aus')) {
                regex = /^[a-zA-Z\s]{2,3}$/
                stateChars = '2 or 3'
            }
            if (!regex.test(supplierInfo?.abbreviatedState.trim())) {
                toast.show({
                    title: 'Warning',
                    description: 'Invalid State. Must be ' + stateChars + ' characters long!'
                })
                return
            }
        }

        const tmpsupplierInfo = { ...supplierInfo }
        const tmpsupplierOldInfo = { ...supplierOldInfo }
        delete tmpsupplierInfo.employerIdNumber;
        delete tmpsupplierOldInfo.employerIdNumber;
        // check that any information of supplier changed or not
        const isBasicInfoChanged = isDiffTwoObj(tmpsupplierInfo, tmpsupplierOldInfo)
        var isEINChanged = false
        // check that EIN changed from some value to some other value
        if (supplierOldInfo?.employerIdNumber && supplierOldInfo?.employerIdNumber !== '' && supplierOldInfo?.employerIdNumber !== supplierInfo?.employerIdNumber) {
            isEINChanged = true;
        }

        dispatch(
            updateSupplierBasicInfo({
                supplierId: relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id,
                basicData: supplierInfo,
                supType: 'related',
                isEINChanged
            })
        ).then(async (res) => {
            if (res?.updatedSupplier?.id) {
                await dispatch(getContacts({ supplierIds: [res?.updatedSupplier?.id], supType: 'relatedMaster' }))
            }
            addSupplierBasicInfoHistory(relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id, supplierInfo, relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo)
            onUpdateCompletenessScore(relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id)
        })
    }

    const addSupplierBasicInfoHistory = (supId, supInfo, supOldInfo) => {
        const tmpSupOldInfo = { ...supOldInfo }
        const contacts = relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.contacts || []
        tmpSupOldInfo.baseInfo.phone = /^\d+$/.test(tmpSupOldInfo.baseInfo.phone) && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpSupOldInfo?.baseInfo?.phone) ? contacts?.find(data => data?.id === parseInt(tmpSupOldInfo.baseInfo.phone))?.phone : (tmpSupOldInfo.baseInfo.phone || '')
        tmpSupOldInfo.baseInfo.email = /^\d+$/.test(tmpSupOldInfo.baseInfo.email) ? contacts?.find(data => data?.id === parseInt(tmpSupOldInfo.baseInfo.email))?.email : (tmpSupOldInfo.baseInfo.email || '')
        var changeLogNotes = generateSupplierBasicInfoChangeLog(tmpSupOldInfo, supInfo);
        if (changeLogNotes !== '') {
            dispatch(
                addSupplierHistory({
                    supplierId: supId,
                    note: changeLogNotes,
                    noteType: 'changelog'
                })
            )
        }
    }

    const handleCreateChild = () => {
        setShowCreateChild(true)
    }

    const handleClose = async (isGetChildData = false) => {
        setShowCreateChild(false)
    }

    // card header function
    const getCardHeader = (isResponsive = false) => {
        return (
            <div className={`${isResponsive ? 'ps-0 mb-3 gap-2 d-flex d-md-none' : ''} card-header h-auto align-items-center`}>
                {!isResponsive && <div className='d-flex align-items-center'>
                    <h3 className='fw-bold mb-0'>{isLocationMaster ? 'Location Master Information' : 'Related Supplier Information'}</h3>
                    <div className={`${!isResponsive ? 'ms-auto' : ''} d-flex flex-wrap pe-2 pe-md-5`}>
                        {isLocationMaster && (
                            <button
                                type="button"
                                className="fs-4 px-4 p-3 text-white rounded mb-0 bg-dark-blue me-3"
                                onClick={handleCreateChild}
                            >
                                Create Child
                            </button>
                        )}
                        <button
                            type="button"
                            className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4 me-2 bg-light-gray text-white width-100"
                            onClick={handleCancelSupplierInfo}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4 btn-green width-100"
                            onClick={handleSaveRelatedEIN}
                        >
                            Save
                        </button>
                    </div>
                </div>
                }
                <div className={`${!isResponsive ? 'd-none d-md-flex justify-space-between flex-wrap align-items-center' : 'd-flex flex-column align-items-start gap-2'}`}>
                    {!supplierInfo?.id ? (
                        <div className='d-flex align-items-center w-100'>
                            <h3 className='fw-bold mb-0'>{isLocationBasedMaster ? 'Location-Based Master Supplier Information' : 'Master Supplier Information'}</h3>
                            <button type="button" className='ms-auto px-4 py-2 fs-5 btn btn-primary' onClick={handleAssignToMaster}>Assign to Master</button>
                        </div>
                    ) : (
                        <h3 className='fw-bold mb-0'>{isLocationBasedMaster ? 'Location-Based Master Supplier Information' : 'Master Supplier Information'}</h3>
                    )}
                    {isLocationMasterEditable && (
                        <div className={`${!isResponsive ? 'ms-auto' : ''} d-flex flex-wrap`}>
                            <button
                                type="button"
                                className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4 me-3 bg-light-gray text-white width-100"
                                onClick={handleCancelSupplierInfo}
                            >
                                Cancel
                            </button>
                            {isValidatingPhone || isValidatingEmail ? (
                                <button
                                    type="button"
                                    className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4 btn-green"
                                >
                                    Validating...
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="card-edit-button me-0 ps-3 pe-3 ps-sm-4 pe-sm-4 btn-green width-100"
                                    onClick={handleSaveSupplierInfo}
                                >
                                    Save
                                </button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }

    const handleSaveRelatedEIN = () => {
        if (relatedSupplierInfo?.employerIdNumber && relatedSupplierInfo?.employerIdNumber !== '' && !/^(\d{2}-\d{7})?$/.test(relatedSupplierInfo?.employerIdNumber)) {
            toast.show({
                title: 'Warning',
                description: 'Invalid Employee Id Number. Must be 9 digit number formatted xx-xxxxxxx.'
            })
            return
        }

        var isEINChanged = false
        // check that EIN changed from some value to some other value
        if (isLocationMaster && relatedSupplierOldInfo?.employerIdNumber && relatedSupplierOldInfo?.employerIdNumber !== '' && relatedSupplierOldInfo?.employerIdNumber !== relatedSupplierInfo?.employerIdNumber) {
            isEINChanged = true;
        }

        dispatch(
            updateSupplierBasicInfo({
                supplierId: relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id,
                basicData: relatedSupplierInfo,
                supType: 'relatedEIN',
                isEINChanged
            })
        ).then((res) => {
            addSupplierBasicInfoHistory(relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id, relatedSupplierInfo, relatedSupplierDetails?.relatedSupplierInfo)
            if (isLocationMaster) {
                onUpdateCompletenessScore(relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id)
            }
        })
    }

    const handleRelatedEINChange = (value) => {
        let tmpValue = value
        if (value.length === 3 && value.includes('-')) {
            value = value.replaceAll('-', '')
        } else if (value.length === 2 || value.length === 3) {
            if (value.length === 3) {
                value = value.substring(0, 2) + '-' + value.substring(2)
            } else {
                value += '-'
            }
        }
        if (/^\d{2}(-\d{7})?$/.test(value)) {
            tmpValue = value
        } else {
            tmpValue = value.match(/^\d{1,2}(-\d{0,7})?/gi) ? value.match(/^\d{1,2}(-\d{0,7})?/gi)[0] : ''
        }
        setRelatedSupplierInfo({
            ...relatedSupplierInfo,
            employerIdNumber: tmpValue
        })
    }

    const handleAssignToMaster = () => {
        setShowSearchOptions(true)
    }

    const closeModal = () => {
        setShowSearchOptions(false)
    }

    const handleConfirmClick = (relatedSupplierId, masterId, masterSupplierName) => {
        if (masterId) {
            setIsLoading(true)
            dispatch(
                assignChildToMasterSupplier({
                    supplierId: relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id,
                    masterId: masterId
                })
            ).then(async () => {
                let note = 'Child supplier assigned to Master ' + '<a target="_blank" href="/suppliers/' + masterId + '"><b>' + masterSupplierName + '</b></a> by <b><em>' + user?.firstname + ' ' + user?.lastname + '</em></b>';
                await addCreateMasterHistory(relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id, note)
                setIsLoading(false)
                onAssignedMaster(relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id)
                closeModal()
            }).catch(() => {
                setIsLoading(false)
            })
        }
    }

    const handleCreateMasterConfirmClick = () => {
        onAssignedMaster(relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id)
        closeModal()
    }

    const addCreateMasterHistory = async (supplierId, note = '') => {
        await dispatch(
            addSupplierHistory({
                supplierId: supplierId,
                note: note,
                noteType: 'changelog'
            })
        )
    }

    const parseAddress = async () => {
        if (supplierInfo?.address1) {
            try {
                setIsParsingAddress(true)
                const addressResult = await dispatch(parseFullAddress(supplierInfo?.address1))
                const parsedResult = getParsedAddress(addressResult)
                setSupplierInfo({
                    ...supplierInfo,
                    'address1': parsedResult?.add1 ? parsedResult?.add1 : '',
                    'address2': parsedResult?.add2 ? parsedResult?.add2 : '',
                    'city': parsedResult?.city ? parsedResult?.city?.value : '',
                    'state': parsedResult?.state ? parsedResult?.state?.value : '',
                    'abbreviatedState': parsedResult?.state ? parsedResult?.state?.value : '',
                    'country': parsedResult?.country ? parsedResult?.country?.value : '',
                    'zip': parsedResult?.zip ? parsedResult?.zip?.value : ''
                })
                setIsParsingAddress(false)
            } catch (err) {
                setIsParsingAddress(false)
            }
        }
    }

    const onContactMouseHover = (event, type = 'master') => {
        const parentWithClass = event.target.closest('.phone-input-parent')
        if (event.target?.dataset?.contactId) {
            const contact = type === 'master' ? allContacts?.find(data => data?.id === parseInt(event.target?.dataset?.contactId)) : relatedSupplierDetails?.relatedSupplierInfo?.contacts?.find(data => data?.id === parseInt(event.target?.dataset?.contactId))
            setCurrentContact(contact ? contact : {})
        } else {
            setCurrentContact({})
        }
        if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
            parentWithClass.nextSibling.style.display = 'block'
        } else if (event.target && event.target?.nextSibling && event.target?.nextSibling?.classList?.value?.includes('contact-view')) {
            event.target.nextSibling.style.display = 'block'
        }
    }

    const onContactMouseHoverOut = (event) => {
        const parentWithClass = event.target.closest('.phone-input-parent')
        if (parentWithClass && parentWithClass?.nextSibling && parentWithClass?.nextSibling.classList?.value?.includes('contact-view')) {
            parentWithClass.nextSibling.style.display = 'none'
        } else if (event.target && event.target?.nextSibling && event.target?.nextSibling.classList?.value?.includes('contact-view')) {
            event.target.nextSibling.style.display = 'none'
        }
        setCurrentContact({})
    }

    const onPhoneEmailClick = (type1, type2) => {
        setShowAllContacts({ ...showAllContacts, [type1]: !showAllContacts?.[type1], [type2]: false })
        setExistedContacts(allContacts)
    }

    const onPhoneEmailFocusOutClick = () => {
        setShowAllContacts({ ...showAllContacts, email: false, phone: false })
        setExistedContacts(allContacts)
    }

    useEffect(() => {
        if (showAllContacts?.phone && supplierInfo?.phone?.trim() && supplierInfo?.phone?.trim()?.length >= 4) {
            setIsLoadingExistingContacts(true)
            const delayDebounceFn = setTimeout(async () => {
                onGetExistingContacts(supplierInfo?.phone?.trim(), 'phone')
            }, 1000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            setIsLoadingExistingContacts(false)
        }
    }, [supplierInfo?.phone])

    useEffect(() => {
        if (showAllContacts?.email && supplierInfo?.email?.trim() && supplierInfo?.email?.trim()?.length >= 4) {
            setIsLoadingExistingContacts(true)
            const delayDebounceFn = setTimeout(async () => {
                onGetExistingContacts(supplierInfo?.email?.trim(), 'email')
            }, 1000)

            return () => clearTimeout(delayDebounceFn)
        } else {
            setIsLoadingExistingContacts(false)
        }
    }, [supplierInfo?.email])

    const onGetExistingContacts = (searchValue, type = '') => {
        try {
            setIsLoadingExistingContacts(true)
            dispatch(getExistingContacts({ searchValue, type })).then((res) => {
                if (res?.contacts && res?.contacts?.length > 0) {
                    if (relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id) {
                        res?.contacts.sort((a, b) => {
                            const aContains = a?.supplierIds.includes(relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id) ? 1 : 0;
                            const bContains = b?.supplierIds.includes(relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id) ? 1 : 0;
                            return bContains - aContains;
                        })
                    }
                    setExistedContacts(res?.contacts)
                } else {
                    setExistedContacts([])
                }
                setIsLoadingExistingContacts(false)
            }).catch(() => {
                setExistedContacts([])
                setIsLoadingExistingContacts(false)
            })
        } catch (err) {
            setExistedContacts([])
            setIsLoadingExistingContacts(false)
        }
    }

    const handleContactClick = async (rowData) => {
        const tmpData = { ...supplierInfo }
        if (showAllContacts?.phone) {
            if (!rowData?.phone) {
                toast.show({
                    title: 'Warning',
                    description: 'No phone number is assigned to this contact!'
                })
                return
            }
            tmpData.phone = rowData?.phone || ''
            tmpData.phoneContactId = rowData?.id || null
            await handlePhoneNumberFocusOut(null, null, tmpData.phone, false)
        }
        if (showAllContacts?.email) {
            if (!rowData?.email) {
                toast.show({
                    title: 'Warning',
                    description: 'No email is assigned to this contact!'
                })
                return
            }
            tmpData.email = rowData?.email || ''
            tmpData.emailContactId = rowData?.id || null
            await handleEmailFocusOut(tmpData.email)
        }
        setSupplierInfo(tmpData)
        onPhoneEmailFocusOutClick()
        if (rowData) {
            const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
            const index = tmpContacts?.findIndex(data => data?.id === rowData?.id)
            if (index === -1) {
                tmpContacts.push(rowData)
            }
            setAllContacts(tmpContacts)
            setExistedContacts(tmpContacts)
        }
    }

    const handleOnCreateContact = () => {
        let value = ''
        let colName = ''
        if (showAllContacts?.phone) {
            colName = 'phone'
            value = supplierInfo?.phone ? (!/^\s*(?:\+?(\d{1,3})\s)/.test(supplierInfo?.phone) ? `1 ${supplierInfo?.phone}` : supplierInfo?.phone) : ''
        } else {
            colName = 'email'
            value = supplierInfo?.email || ''
        }
        setContactDataFromField({
            colName: colName,
            value: value
        })
        setShowAddNewContact(true)
        onPhoneEmailFocusOutClick()
    }

    const handleCreateContactClose = async (e, isGetContactsData = false, contact = null) => {
        const contactId = contact?.id || null
        const tmpData = { ...supplierInfo }
        if (contactId) {
            contact.contactName = contact?.firstname + ' ' + contact?.lastname
            const tmpContacts = allContacts && allContacts?.length > 0 ? [...allContacts] : []
            tmpContacts.push(contact)
            if (contactDataFromField?.colName === 'email') {
                tmpData.email = contact?.email || ''
                tmpData.emailContactId = contactId || null
                setSupplierInfo(tmpData)
                await handleEmailFocusOut(tmpData.email)
            } else {
                tmpData.phone = contact?.phone || ''
                tmpData.phoneContactId = contactId || null
                setSupplierInfo(tmpData)
                await handlePhoneNumberFocusOut(null, null, tmpData.phone)
            }
            setAllContacts(tmpContacts)
            setExistedContacts(tmpContacts)
        }

        setContactDataFromField({})
        setShowAddNewContact(false)
    }

    const onGetContactsData = () => {
        if (showAllContacts?.email) {
            onGetExistingContacts(supplierInfo?.email?.trim(), 'email')
        }
        if (showAllContacts?.phone) {
            onGetExistingContacts(supplierInfo?.phone?.trim(), 'phone')
        }
    }

    const handleRemoveContact = (colName) => {
        if (colName === 'email') {
            setSupplierInfo({ ...supplierInfo, emailContactId: null, email: '' })
            setIsEmailValid(true)
        } else {
            setSupplierInfo({ ...supplierInfo, phoneContactId: null, phone: '' })
            setIsPhoneValid(true)
        }
    }

    return (
        <div className={`card related-supply-information-component`}>
            {getCardHeader(false)}
            <div className="card-content list flex-md-row flex-column">
                <div className='related-supplier-information'>
                    {
                        relatedSupplierColumns.map((col, index) => (
                            <React.Fragment key={col.name}>
                                {
                                    index === 1 && (
                                        <div className="item pe-2 pe-md-5 flex-column flex-sm-row align-items-start align-items-sm-center" key="relatedSupplierid">
                                            <h4 className="label">Supplier Id:</h4>
                                            <input
                                                className='related-supplier-id'
                                                type="text"
                                                value={relatedSupplierInfo['id'] || ''}
                                                disabled={true}
                                            />
                                        </div>
                                    )
                                }
                                <div className="item pe-2 pe-md-5 flex-column flex-sm-row align-items-start align-items-sm-center" key={col.name}>
                                    <h4 className="label">{col.label}:</h4>
                                    {
                                        col.name === 'phone' ?
                                            <div className="phone-input-parent flex align-center">
                                                <div className='d-flex border rounded border-dark phone-input-ext-container w-100 flex-column flex-lg-row position-relative'>
                                                    <ReactPhoneInput
                                                        className='phone-input-parent'
                                                        country={'us'}
                                                        value={relatedSupplierInfo[col.name]}
                                                        countryCodeEditable={false}
                                                        preferredCountries={['us']}
                                                        ref={phoneInputRefname}
                                                        disabled={true}
                                                        buttonClass='border-0 border-end border-dark'
                                                        inputProps={{
                                                            className: 'form-control border-0 text-primary',
                                                            onMouseOver: (e) => { onContactMouseHover(e, 'child') },
                                                            onMouseOut: (e) => { onContactMouseHoverOut(e) },
                                                            'data-contact-id': relatedSupplierInfo?.phoneContactId || ''
                                                        }}
                                                    />
                                                    {relatedSupplierInfo?.[col.name] && !showAllContacts?.phone && (
                                                        <ContactView contact={currentContact} />
                                                    )}
                                                    <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                        <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                        <input type="text" className="shadow-none form-control w-auto border-0 ps-3 pe-3" placeholder="phone extension" disabled={true} />
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            col.name === 'email' ?
                                                <div className="phone-input-parent flex align-center position-relative">
                                                    <input
                                                        className={`basicvalue text-primary`}
                                                        type="text"
                                                        value={relatedSupplierInfo?.[col.name] || ''}
                                                        disabled={true}
                                                        onMouseOver={(e) => { onContactMouseHover(e, 'child') }}
                                                        onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                        data-contact-id={relatedSupplierInfo?.emailContactId || ''}
                                                    />
                                                    {relatedSupplierInfo?.[col.name] && !showAllContacts?.email && (
                                                        <ContactView contact={currentContact} />
                                                    )}
                                                </div>
                                                :
                                                <input
                                                    className={`basicvalue ${col.name === 'zip' ? 'supplier-zip-input' : ''} ${col.name === 'country' ? 'supplier-country-input' : ''}`}
                                                    type="text"
                                                    value={relatedSupplierInfo?.[col.name] || ''}
                                                    disabled={col.name === 'employerIdNumber' ? false : true}
                                                    onChange={(e) => col.name === 'employerIdNumber' && handleRelatedEINChange(e.target.value)}
                                                />
                                    }
                                </div>

                            </React.Fragment>
                        ))
                    }
                </div>

                {getCardHeader(true)}

                <div className='master-supplier-information'>
                    {
                        relatedSupplierColumns.map((col, index) => (
                            <React.Fragment key={col.name}>
                                {
                                    index === 1 && (
                                        <div className="item flex-column flex-sm-row align-items-start align-items-sm-center pe-0" key="masterid">
                                            <h4 className="label d-md-none d-block">Supplier Id:</h4>
                                            <input
                                                className='master-supplier-id'
                                                type="text"
                                                value={supplierInfo?.['id'] || ''}
                                                disabled={true}
                                            />
                                        </div>
                                    )
                                }
                                <div className="item flex-column flex-sm-row align-items-start align-items-sm-center pe-0" key={col.name}>
                                    <h4 className="label d-md-none d-block">{col.label}:</h4>
                                    {
                                        col.name === 'phone' ?
                                            <div className="phone-input-parent flex align-center">
                                                <div className={`d-flex border rounded border-dark phone-input-ext-container w-100 flex-column flex-lg-row position-relative${supplierInfo?.phoneContactId ? ' input-group' : ''}`}>
                                                    {supplierInfo?.phoneContactId && (
                                                        <span role='button' class='border border-start-0 border-top-0 border-bottom-0 border-dark input-group-text text-red px-3 fs-2 fw-bold mb-0' onClick={() => { handleRemoveContact('phone') }}>X</span>
                                                    )}
                                                    <input
                                                        value={supplierInfo[col.name] || ''}
                                                        className={`basicvalue text-primary border-0 ms-0${supplierInfo?.phoneContactId ? ' w-auto' : ''}`}
                                                        onChange={e => handleChangeSupplierInfo(col.name, e.target.value)}
                                                        onClick={() => { onPhoneEmailClick('phone', 'email') }}
                                                        onMouseOver={(e) => { onContactMouseHover(e) }}
                                                        onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                        data-contact-id={supplierInfo?.phoneContactId || ''}
                                                        autoComplete='no-phone'
                                                        disabled={!isLocationMasterEditable}
                                                    // onClick={() => { isLocationMasterEditable && onPhoneEmailClick('phone', 'email') }}
                                                    // onBlur={(event) => { isPhoneValid === '' && handlePhoneNumberFocusOut(event, null, supplierInfo[col.name]) }}
                                                    />
                                                    {supplierInfo?.[col.name] && !showAllContacts?.phone && (
                                                        <ContactView contact={currentContact} />
                                                    )}
                                                    {showAllContacts?.phone && (
                                                        <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={handleOnCreateContact} supplierId={relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                                    )}
                                                    <div className="input-group phone-extension-container mb-0 flex-nowrap">
                                                        <span className="h4 mb-0 d-flex text-dark align-items-center border-0 border-start border-dark rounded-0 bg-white" id="phone_ext">Ext.</span>
                                                        <input
                                                            type="text"
                                                            className="shadow-none form-control w-auto border-0 ps-3 pe-3"
                                                            placeholder="phone extension"
                                                            value={supplierInfo?.['phoneExtension'] || ''}
                                                            onChange={(e) => { handleChangeSupplierInfo('phoneExtension', e.target.value) }}
                                                            disabled={isLocationMasterEditable ? ((!supplierInfo?.['phone'] || !isPhoneValid || supplierInfo?.['phone'] === countryCode) ? true : false) : true}
                                                        />
                                                    </div>
                                                </div>
                                                {isValidatingPhone && (<Loader />)}
                                                {supplierInfo[col.name] && !isValidatingPhone && isPhoneValid !== '' &&
                                                    (isPhoneValid ?
                                                        <BsCheckSquare color="#067911" size={26} />
                                                        :
                                                        <BsXSquare color="#f75a52" size={26} />
                                                    )
                                                }
                                            </div>
                                            :
                                            col.name === 'email' ?
                                                <div className={`phone-input-parent flex align-center position-relative${supplierInfo?.phoneContactId ? ' input-group align-items-center' : ''}`}>
                                                    {supplierInfo?.emailContactId && (
                                                        <span role='button' class='border border-end-0 border-dark input-group-text text-red px-3 fs-2 fw-bold mb-0' onClick={() => { handleRemoveContact('email') }} style={{ height: '48px' }}>X</span>
                                                    )}
                                                    <input
                                                        style={{ marginLeft: supplierInfo?.emailContactId ? '-10px' : '0' }}
                                                        className={`basicvalue text-primary${supplierInfo?.phoneContactId ? ' w-auto flex-grow-1' : ''}`}
                                                        type="text"
                                                        value={supplierInfo[col.name] || ''}
                                                        onChange={e => handleChangeSupplierInfo(col.name, e.target.value)}
                                                        onClick={() => { onPhoneEmailClick('email', 'phone') }}
                                                        // onBlur={() => { isEmailValid === '' && handleEmailFocusOut(supplierInfo?.[col.name]) }}
                                                        disabled={!isLocationMasterEditable}
                                                        onMouseOver={(e) => { onContactMouseHover(e) }}
                                                        onMouseOut={(e) => { onContactMouseHoverOut(e) }}
                                                        data-contact-id={supplierInfo?.emailContactId || ''}
                                                        autoComplete='no-email'
                                                    />
                                                    {supplierInfo?.[col.name] && !showAllContacts?.email && (
                                                        <ContactView contact={currentContact} />
                                                    )}
                                                    {showAllContacts?.email && (
                                                        <AllContacts contacts={existedContacts} onClose={onPhoneEmailFocusOutClick} onCreateContact={handleOnCreateContact} supplierId={relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id} isLoading={isLoadingExistingContacts} onContactClick={handleContactClick} onGetContactsData={onGetContactsData} />
                                                    )}
                                                    {isValidatingEmail && (<Loader />)}
                                                    {supplierInfo?.[col.name] && !isValidatingEmail && isEmailValid !== '' &&
                                                        (
                                                            isEmailRisky ?
                                                                <BsCheckSquare color="#EFD700 " size={26} /> :
                                                                isEmailValid ?
                                                                    <BsCheckSquare color="#067911" size={26} />
                                                                    :
                                                                    <>
                                                                        <BsXSquare color="#f75a52" size={26} />
                                                                        {/* <MdOutlineChangeCircle
                                                                            title='Retry'
                                                                            role='button'
                                                                            color="#14438b"
                                                                            size={30}
                                                                            onClick={() => { handleEmailFocusOut(supplierInfo[col.name], true) }}
                                                                        /> */}
                                                                    </>
                                                        )
                                                    }
                                                </div>
                                                :
                                                col.name === 'suppliername' ?
                                                    <>
                                                        {(isLocationMasterEditable || !supplierInfo?.[col.name]) ?
                                                            <input
                                                                className={`basicvalue ${col.name === 'zip' ? 'supplier-zip-input' : ''} ${col.name === 'country' ? 'supplier-country-input' : ''}`}
                                                                type="text"
                                                                value={supplierInfo?.[col.name] || ''}
                                                                disabled={!isLocationMasterEditable}
                                                                onChange={e => handleChangeSupplierInfo(col.name, e.target.value)}
                                                            />
                                                            :
                                                            <a className='master-supplier-link d-flex align-items-center text-primary' target="_blank" href={`/suppliers/${supplierInfo?.['id']}`}>
                                                                {supplierInfo?.[col.name]}
                                                            </a>
                                                        }
                                                    </>
                                                    :
                                                    <>
                                                        <input
                                                            className={`basicvalue ${col.name === 'zip' ? 'supplier-zip-input' : ''} ${col.name === 'country' ? 'supplier-country-input' : ''}`}
                                                            type="text"
                                                            value={supplierInfo?.[col.name] || ''}
                                                            disabled={!isLocationMasterEditable}
                                                            onChange={e => handleChangeSupplierInfo(col.name, e.target.value)}
                                                        />
                                                        {col.name === 'address1' && supplierInfo?.address1 && (
                                                            <div className="position-relative text-center ms-3" style={{ height: "48px" }}>
                                                                {isParsingAddress && <Loader size="sm" className="top-33 position-absolute start-0 end-0" />}
                                                                <button
                                                                    type="button"
                                                                    className={`${isParsingAddress ? 'bg-light ' : ''}h-100 ps-3 pe-3 ps-sm-4 pe-sm-4 width-100 bg-dark-blue rounded text-white`}
                                                                    onClick={parseAddress}
                                                                >
                                                                    Parse Address
                                                                </button>
                                                            </div>
                                                        )}
                                                    </>
                                    }
                                </div>
                            </React.Fragment>
                        ))
                    }
                </div>
            </div>
            {showSearchOptions && (
                <SearchModal
                    show={showSearchOptions}
                    onGoBack={() => { closeModal() }}
                    selectedVendor={relatedSupplierInfo}
                    isFromRelatedSuppliers={true}
                    onConfirm={handleConfirmClick}
                    isLoading={isLoading}
                    setShowCreateMasterModal={setShowCreateMasterModal}
                />
            )}
            {showCreateMasterModal && (
                <Modal
                    backdrop='static'
                    className="create-supplier-modal"
                    show={showCreateMasterModal}
                    size="lg"
                    onClick={() => { setShowCreateMasterModal(false) }}
                    onHide={() => { setShowCreateMasterModal(false) }}>
                    <Modal.Header></Modal.Header>
                    <Modal.Body>
                        <CreateMasterModal
                            isFromRelatedSupplier={true}
                            isFromList={false}
                            selectedKeys={[relatedSupplierDetails?.relatedSupplierInfo?.baseInfo?.id]}
                            listSupplier={relatedSupplierInfo}
                            onClose={() => { setShowCreateMasterModal(false) }}
                            onUpdateListSupplier={handleCreateMasterConfirmClick}
                            isCreatingMasterFromList={isLoading}
                        />
                    </Modal.Body>
                </Modal>
            )}

            {showCreateChild && (
                <>
                    <ModalComponent size='xl' modalTitle='Create Child' open={showCreateChild} handleClose={handleClose} dialogClassName='create-child-modal-dialog'
                    >
                        <CreateChildVendorFromMaster
                            masterSupplierData={relatedSupplierInfo}
                            onClose={handleClose}
                            isFromCalls={false}
                            listSupplierId={null}
                            locationMasterData={isLocationMaster ? relatedSupplierDetails?.relatedSupplierInfo?.baseInfo : null}
                            contacts={relatedSupplierDetails?.relatedSupplierInfo?.contacts || []}
                        />
                    </ModalComponent>
                </>
            )}
            {showAddNewContact && (
                <>
                    <ModalComponent size='xl' modalTitle='' open={showAddNewContact} handleClose={handleCreateContactClose} dialogClassName='px-5 create-new-contact-modal-dialog'>
                        <CreateContact onClose={handleCreateContactClose} supplierId={relatedSupplierDetails?.relatedSupplierInfo?.masterSupplierInfo?.baseInfo?.id} contactDataFromField={contactDataFromField} />
                    </ModalComponent>
                </>
            )}
        </div>
    )
}

export default RelatedSupplyInformation